import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Zone } from '../../models/zone';
import { ZoneService } from '../../services/zone.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';

@Component({
  selector: 'app-zone',
  templateUrl: './zone.component.html',
  styleUrls: ['./zone.component.css']
})
export class ZoneComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerZone: PageHeader;
  entity: Zone = new Zone();
  selectedZone: Zone = new Zone();
  editingEntity: Zone = new Zone();
  zones: any;
  zoneColumns: any[] = [];
  listView: boolean = true;
  formCaption: string = '';
  company: Array<Company> = [];
  selectedCompany: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  opened: boolean = false;
  details: any;

  constructor(
    private _zoneService: ZoneService,
    private _companyService: CompanyService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private _employeeService: EmployeeService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerZone = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));

    this.zones = [];
    this.getAllZone();
  }
  ngAfterViewInit(): void {

    this.zoneColumns = [
      { field: "SlNo", title: "SL No.", filter: false, sortable: true, width: 90 },
      { field: "ZoneName", title: 'Zone', filter: true, sortable: true, width: 100 },
      { field: "Code", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "EmployeeName", title: 'Zone Head', filter: true, sortable: true, width: 150 },
      { field: "ZoneMail", title: 'Email Id', filter: true, sortable: true, width: 150 },
      { field: "ZonePhone", title: 'Phone', filter: true, sortable: true, width: 150 },
      { field: "CompanyName", title: 'Company', filter: true, sortable: true, width: 150 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 150 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }

  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._zoneService.getAllZones('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Zone>) => {
      this.zones = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }
  getAllEmployees(filter: string) {
    this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
      this.employees = data;
    })
  }
  onPaste(event: any) {
    let Data = event.Data;
    let regexp = new RegExp('[^-_().;:,!a-zA-Z0-9/ ]');
    let pastedText = Data.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^a-zA-Z0-9-()._ ]/g, '');
    (<HTMLInputElement>document.getElementById('bindingId')).value = trimmedText;
    if (test) {
      event.preventDefault();
    }
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._zoneService.getAllZones(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((zones: Array<Zone>) => {
        this.zones = {
          data: zones,
          total: zones[0] ? zones[0].TotalCount : 0
        }
      });
    }
  }
  getAllZone() {
    this._zoneService.getAllZones('', Number(this.defaultPageSize), 1, 0, 0).subscribe((zones: Array<Zone>) => {
      this.zones = {
        data: zones,
        total: zones[0] ? zones[0].TotalCount : 0
      }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._zoneService.deleteZone(this.selectedZone.Zone_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearZone();
            this.getAllZone();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerZone = new PageHeader();
    headerZone.PageCaption = "Zone";
    headerZone.IconClass = "bi bi-shield-shaded";
    return headerZone;
  }

  deleteZone(event: any) {
    if (event.seletedRows[0]) {
      this.selectedZone.Zone_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Zone",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  goToBackTab(): void {
    this.listView=true;
}
  addZone(event: any) {
    this.listView = false;
    this.clearZone();
    this.getAllCompany('');
    this.getAllEmployees('');
    this.formCaption = "Add Zone";
  }

  editZone(event: any): void {
    if (event.seletedRows[0]) {
      this._zoneService.viewZone(event.seletedRows[0]).subscribe((zones: Array<Zone>) => {
        let editEnity = zones[0] ? zones[0] : new Zone();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.selectedEmployee = { Emp_Ref_Id: editEnity.Emp_Ref_Id, EmployeeName: editEnity.EmployeeName };

          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Zone";
          this.getAllCompany('');
          this.getAllEmployees('');
          this.entity.EntityMetaData = [
            { FieldName: 'ZoneName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Phone is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Email is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone Head is required' },    
            //{ FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {

    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {

if(this.entity.Phone != ""){
      if (this.entity.Phone.length != 10) {
        this.notification.showWarning("Invalid Phone No.");
        this.saveDisabled = false;
        return;
      }
    }
      if (parseInt(this.entity.Code) == 0) {
        this.notification.showWarning('Zero not allowed ');
        return
      }
      this._zoneService.checkDuplication(this.entity.Zone_Id, this.entity.Code).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Zone Code already exists');
          this.saveDisabled = false;
        }
          if (this.entity.EmailId != "") {
            // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;commented on 04-06-2024 by jessil for #I238
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
            if (this.emailcheck === false) {
              this.notification.showWarning("Email not valid");
              this.saveDisabled = false;
              return
            }
          }

            // else {
              this._zoneService.checkEmail(this.entity.EmailId, this.entity.Zone_Id).subscribe((response) => {
                if (response.Success == false) {
                  this.notification.showWarning("Email already exists");
                  this.saveDisabled = false;
                }
                else {
                  this._zoneService.saveZone(this.entity).subscribe(() => {
                    if (this.entity.Zone_Id == '00000000-0000-0000-0000-000000000000') {
                      this.notification.showSuccess('Saved Successfully');
                    }
                    else {
                      this.notification.showSuccess('Updated Successfully');
                    }
                    this.listView = true;
                    this.clearZone();
                    this.getAllZone();
                  });

                }
              });
            // }
          // }
      });
    }
    else {
      this.saveDisabled = false;
    }

  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllZone();
  }

  refreshZones(event: any): void {
    this.zones = [];
    this.getAllZone();
  }

  clearZone(): void {
    this.selectedCompany = {};
    this.selectedEmployee = {};
    this.entity = new Zone();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Zone_Id = dataItem.Zone_Id;
    this.details = [];
    this._zoneService.viewZone(this.entity.Zone_Id).subscribe((zone: Array<Zone>) => {
      this.opened = true;
      this.details = zone[0];
    });
  }
}
